import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getSupplierDropdownFilter = createApi(`SupplierDropdownFilterSlice`,"GET");

const SupplierDropdownFilterSlice = createSlice({
  name: 'SupplierDropdownFilterSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSupplierDropdownFilter.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSupplierDropdownFilter.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getSupplierDropdownFilter.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default SupplierDropdownFilterSlice.reducer;